import React, { useEffect, useState } from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { supabase } from '../../lib/supabaseClient';

const DashboardIndex = () => {
  const [user, setUser] = useState(null);
  const [unreadCount, setUnreadCount] = useState(0);

  // ✅ Moved here so it’s accessible to all useEffects
  const getUserAndUnread = async () => {
    const { data: { user } } = await supabase.auth.getUser();
    if (user) {
      setUser(user);
      const { count, error } = await supabase
        .from('user_announcements')
        .select('*', { count: 'exact', head: true })
        .eq('user_id', user.id)
        .eq('is_read', false);

      if (!error) setUnreadCount(count || 0);
    }
  };

  // 🔁 Fetch on load + every 10 seconds
  useEffect(() => {
    getUserAndUnread();
    const interval = setInterval(getUserAndUnread, 10000);
    return () => clearInterval(interval);
  }, []);

  // 📣 Listen for custom refresh events
  useEffect(() => {
    const handler = () => getUserAndUnread();
    window.addEventListener("refresh-unread-count", handler);
    return () => window.removeEventListener("refresh-unread-count", handler);
  }, []);

  return (
    <div className="min-h-screen flex bg-indigo-50">
      {/* Sidebar */}
      <aside className="w-64 bg-white shadow-md p-6 space-y-4">
        <h2 className="text-2xl font-bold text-indigo-800 mb-6">My Dashboard</h2>
        <nav className="flex flex-col space-y-2">
          <NavLink to="/dashboard" end className={({ isActive }) =>
            `py-2 px-4 rounded hover:bg-indigo-100 font-medium ${isActive ? 'bg-indigo-100 text-indigo-800' : 'text-gray-700'}`
          }>
            Home
          </NavLink>
          <NavLink to="/dashboard/progress" className={({ isActive }) =>
            `py-2 px-4 rounded hover:bg-indigo-100 font-medium ${isActive ? 'bg-indigo-100 text-indigo-800' : 'text-gray-700'}`
          }>
            Progress
          </NavLink>
          <NavLink to="/dashboard/certificates" className={({ isActive }) =>
            `py-2 px-4 rounded hover:bg-indigo-100 font-medium ${isActive ? 'bg-indigo-100 text-indigo-800' : 'text-gray-700'}`
          }>
            Certificates
          </NavLink>
          <NavLink to="/dashboard/profile" className={({ isActive }) =>
            `py-2 px-4 rounded hover:bg-indigo-100 font-medium ${isActive ? 'bg-indigo-100 text-indigo-800' : 'text-gray-700'}`
          }>
            Profile
          </NavLink>
          <NavLink to="/dashboard/messages" className={({ isActive }) =>
            `py-2 px-4 rounded hover:bg-indigo-100 font-medium flex justify-between items-center ${isActive ? 'bg-indigo-100 text-indigo-800' : 'text-gray-700'}`
          }>
            <span>Messages</span>
            {unreadCount > 0 && (
              <span className="ml-2 inline-block min-w-[20px] text-center text-sm text-white bg-red-600 rounded-full px-1">
                {unreadCount}
              </span>
            )}
          </NavLink>
        </nav>
      </aside>

      {/* Main Content */}
      <main className="flex-1 p-8">
        <Outlet />
      </main>
    </div>
  );
};

export default DashboardIndex;
